import React from "react"
import { PrimeiroAgendamentoProvider } from "./contexts/PrimeiroAgendamentoContext"
import { PrimeiroAgendamento } from "./PrimeiroAgendamento"

export const PrimeiroAgendamentoWrapper: React.FC = () => {

    return (
        <PrimeiroAgendamentoProvider>
            <PrimeiroAgendamento />
        </PrimeiroAgendamentoProvider>
    )
}